import { Star } from 'lucide-react';

/**
 * Display star ratings with fractional fill support
 */
export default function RatingStars({ rating, count }) {
  return (
    <div className="flex items-center gap-0.5">
      {[0, 1, 2, 3, 4].map((i) => {
        const fill = Math.max(0, Math.min(1, rating - i));
        return (
          <span key={i} className="relative h-5 w-5">
            <Star className="absolute inset-0 h-5 w-5 text-muted-foreground/40" />
            <span className="absolute inset-0 overflow-hidden" style={{ width: `${fill * 100}%` }}>
              <Star className="h-5 w-5 fill-primary text-primary" />
            </span>
          </span>
        );
      })}
      {count !== undefined && <span className="ml-2 text-xs text-muted-foreground">({count})</span>}
    </div>
  );
}
